const buttonTextUnderstand = 'Entendido ›';
export const ERROR_TEMPLATE_ENUM = {
    CHECKPIN_DEBITCARD_BLOCKED: 1,
    GENERAL_SERVICE_FAILURE: 2,
    SINGLE_SESSION_BLOCKED: 3,
    CONNECTION_ERROR: 4,

    get: {
        1: {
            title: 'Has superado el número de intentos permitido',
            subtitle: 'Por seguridad hemos bloqueado tu ingreso de forma digital. ' +
                'Comunícate con un asesor para continuar con tu solicitud.\n',
            buttonText: buttonTextUnderstand,
            imgClass: 'daily-blockages'
        },
        2: {
            title: 'Tenemos problemas técnicos',
            subtitle: 'Inténtalo en unos minutos.\n',
            buttonText: buttonTextUnderstand,
            imgClass: 'general-service-error'
        },
        3: {
            title: 'Bloqueo por múltiples sesiones',
            subtitle: 'Por seguridad hemos bloqueado tu ingreso de forma digital.\n',
            buttonText: buttonTextUnderstand,
            imgClass: 'daily-blockages'
        },
        4: {
            title: 'Error de conexión',
            subtitle: 'La conexión a internet parece estar inestable o perdida en este momento, ' +
                'Por favor, verifica que tu conexión esté funcionando adecuadamente e intenta de nuevo \n',
            buttonText: buttonTextUnderstand,
            imgClass: 'general-service-error'
        },

    }
} as const



// WEBPACK FOOTER //
// ./src/app/enums/new-error-messages-enum.ts